import { useState, useCallback } from "react";

const useCloudinaryUploader = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [uploadedUrls, setUploadedUrls] = useState([]);

  const uploadToCloudinary = useCallback(
    async (blobs, resourceType = "raw") => {
      setIsLoading(true);
      setIsError(false);

      try {
        // Prepare all the upload promises
        const uploadPromises = blobs.map((blob) => {
          const formData = new FormData();
          formData.append("file", blob);
          formData.append(
            "upload_preset",
            process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET
          );

          return fetch(
            `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_NAME}/${resourceType}/upload`,
            {
              method: "POST",
              body: formData,
            }
          )
            .then((response) =>
              response.ok
                ? response.json()
                : Promise.reject(new Error("Failed to upload"))
            )
            .then((data) => data.secure_url);
        });

        // Execute all upload promises in parallel
        const results = await Promise.all(uploadPromises);
        setUploadedUrls((prev) => [...prev, ...results]);

        return results;
      } catch (err) {
        console.error("Error uploading files to Cloudinary:", err);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return { isLoading, isError, uploadedUrls, uploadToCloudinary };
};

export default useCloudinaryUploader;
